module.exports = __webpack_public_path__ + "img/running-girl.635bd396.png";